import React from 'react';

import { StyleSheet } from 'react-native';
import type { TextStyle } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { LoyaltyNoRewardPoints } from 'pages/loyalty/loyalty-no-reward-points';
import { primitive, spacing } from 'styles/constants';

import LoyaltyClaimPointsLink from '../loyalty-claim-points/loyalty-claim-points-link';

const styles = StyleSheet.create({
  header: {
    fontWeight: primitive.$fontWeightHeavy as TextStyle['fontWeight'],
  },
  rightHeader: {
    flex: 1,
    textAlign: 'right',
  },
  leftHeader: {
    flexGrow: 1,
    textAlign: 'left',
  },
  centerHeader: {
    flexGrow: 1,
    paddingRight: spacing.$4,
    textAlign: 'center',
  },
  transactionDateAndTime: {
    alignItems: 'flex-start',
  },
});

export const RightHeader = withTypography({
  style: [styles.header, styles.rightHeader],
});

export const LeftHeader = withTypography({
  style: [styles.header, styles.leftHeader],
});

export const CenterHeader = withTypography({
  style: [styles.header, styles.centerHeader],
});

export const TransactionDateAndTime = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.transactionDateAndTime, style] });

export const TransactionDate = withTypography({ fontSize: 'md' });

export const TransactionTime = withTypography({ fontSize: 'xs' });

export const StyledLoyaltyClaimPointsLink = LoyaltyClaimPointsLink.withConfig({
  marginY: '$4',
  marginX: 'auto',
  paddingY: '$3',
  paddingX: '$5',
});

export const StyledLoyaltyNoRewardPoints = LoyaltyNoRewardPoints;
